const InstrumentData = ({ data }) => {
    return (
        data && (
            <div className='InstrumentData--V2__Header Fonts--PlusJakartaSans'>
                {data.block && data.block !== '' && <p className='InstrumentData--V2__Text--Subtitle InstrumentData--V2__Text--BottomZero'>Bloque: {data.block}</p>}
                {data.topic && data.topic !== '' && <p className='InstrumentData--V2__Text--Title InstrumentData--V2__Text--BottomSmall'>{data.topic}</p>}
                {data.steps && data.steps.start && data.steps.end && <p className='InstrumentData--V2__Text--Subtitle InstrumentData--V2__Text--Small InstrumentData--V2__Text--BottomZero'>Tema {data.steps.start} de {data.steps.end}</p>}
            </div>
        )
    )
}

export { InstrumentData };